import { YStack } from 'tamagui';
import { ListSection } from './ListSection';
import { ListProps } from './list.types';

/**
 * Generic List component that renders sections with items.
 * Each section has a title and contains list items.
 */
export const List = ({ sections, gap = '$4' }: ListProps): React.ReactNode => {
  return (
    <YStack gap={gap}>
      {sections.map((section, index) => (
        <ListSection
          key={section.id || index}
          title={section.title}
          items={section.items}
        />
      ))}
    </YStack>
  );
};
